/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemFolderWrapper_item = {
    readonly serviceId: string | null;
    readonly folderPortfolioItems?: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"Folder_folderPortfolioItems">;
    } | null> | null;
    readonly " $refType": "ItemFolderWrapper_item";
};
export type ItemFolderWrapper_item$data = ItemFolderWrapper_item;
export type ItemFolderWrapper_item$key = {
    readonly " $data"?: ItemFolderWrapper_item$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemFolderWrapper_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "loadPortfolioData"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemFolderWrapper_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "condition": "loadPortfolioData",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "folderPortfolioItems",
          "args": [
            {
              "kind": "Literal",
              "name": "portfolioType",
              "value": "FOLDER"
            },
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "PortfolioItemV2",
          "kind": "LinkedField",
          "name": "portfolioItems",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Folder_folderPortfolioItems"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '4866fa2e4af049da61e235003e0dc744';
export default node;
